import { useEffect } from 'react';
import { assetUrl } from '@/utils/asset-url';

/*
 * useAssetCssVars — bridges PUBLIC_URL-prefixed asset paths into CSS custom
 * properties so SCSS `background-image` rules resolve under the unified-portal
 * prefix (/admin, /pitstop). SCSS can't read PUBLIC_URL or call assetUrl, so
 * each `url('/...')` in SCSS was swapped to `var(--x, url('/...'))` and this
 * hook fills `--x` with the correctly-prefixed URL at startup.
 *
 * Legacy-safe: assetUrl is a no-op when PUBLIC_URL is '', and the SCSS fallback
 * keeps the original path if the var is ever unset.
 */
const ASSET_CSS_VARS = {
	'--checkbox-tick': '/svgs/tick.svg',
	'--version-card-bg': '/svgs/version-card-bg-style-1.svg',
};

const useAssetCssVars = () => {
	useEffect(() => {
		const root = document.documentElement;
		Object.entries(ASSET_CSS_VARS).forEach(([name, path]) => {
			root.style.setProperty(name, `url(${assetUrl(path)})`);
		});
	}, []);
};

export default useAssetCssVars;
